// =====================================================================
// Assessment Center — Auth module: password hashing.
//
// SHA-256 digest via the Web Crypto API. This is deliberately simple
// per this project's MVP auth requirements ("no advanced security") —
// it avoids storing plaintext passwords, but it is NOT a production
// password hash: there's no per-user salt and no work-factor tuning
// (bcrypt/scrypt/argon2 do both). Before this app has real users,
// registration/login must move server-side and use a real password
// hashing library — this function is scoped to disappear along with
// the rest of local-auth-provider.ts when this module is swapped for
// a real auth provider (see ./types.ts).
// =====================================================================

export async function hashPassword(password: string): Promise<string> {
  const bytes = new TextEncoder().encode(password);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function verifyPassword(password: string, hash: string): Promise<boolean> {
  return (await hashPassword(password)) === hash;
}
